import $ from 'jquery';
import 'slick-carousel';

$(function() {
    // Slick apports
    function handleArrow(event, slick, currentSlide = 0, nextSlide = 1) {
        const current = event.type !== 'beforeChange' ? currentSlide : nextSlide;
        const { $prevArrow, $nextArrow } = slick;

        if (current > 0) {
            const title = slick.$slides.eq(current - 1).find('h1, h2, h3, h4, h5, h6').eq(0).text();
            $prevArrow.text(title);
        }

        if (current < slick.$slides.length - 1) {
            const title = slick.$slides.eq(current + 1).find('h1, h2, h3, h4, h5, h6').eq(0).text();
            $nextArrow.text(title);
        }
    }

    $('.slick-apports').on('init', handleArrow);
    $('.slick-apports').on('beforeChange', handleArrow);

    $('.slick-gallery').on('init', handleArrow);
    $('.slick-gallery').on('beforeChange', handleArrow);

    $('.slick-caroussel').on('init', handleArrow);
    $('.slick-caroussel').on('beforeChange', handleArrow);

    $('.slick-temoignages').on('init', handleArrow);
    $('.slick-temoignages').on('beforeChange', handleArrow);

    $('.slick-25-ans').on('init', handleArrow);
    $('.slick-25-ans').on('beforeChange', handleArrow);

    $('.slick-similar-realisations').on('init', handleArrow);
    $('.slick-similar-realisations').on('beforeChange', handleArrow);

    // Caroussels
    $('.slick-caroussel').slick({
        appendArrows: '.slick-arrow-wrapper',
        infinite: true,
        pauseOnHover: true,
        autoplay: true,
        autoplaySpeed: 10000,
        dots: true,
        rows: 0,
    });

    $('.block-gallery').each(function (index, element) {
        $('.slick-gallery', element).slick({
            appendArrows: $('.slick-gallery-arrows', element),
            slidesToShow: 2,
            slidesToScroll: 1,
            variableWidth: true,
            infinite: false,
            rows: 0,
        });

        $('.slick-prev', element).on('click', () => {
            $('.slick-gallery', element).slick('slickPrev');
        });

        $('.slick-next', element).on('click', () => {
            $('.slick-gallery', element).slick('slickNext');
        });
    });

    $('.slick-similar-realisations').slick({
        appendArrows: '.slick-similar-rea-arrows',
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
        rows: 0,
        responsive: [
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    });

    $('.similar-realisations .slick-prev').on('click', () => {
        $('.slick-similar-realisations').slick('slickPrev');
    });

    $('.similar-realisations .slick-next').on('click', () => {
        $('.slick-similar-realisations').slick('slickNext');
    });

    $('.slick-temoignages').slick({
        appendArrows: '.slick-arrow-wrapper',
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        fade: true,
        speed: 300,
        autoplay: true,
        autoplaySpeed: 7000,
        cssEase: 'linear',
        rows: 0,
    });

    $('.slick-25-ans').slick({
        appendArrows: '.slick-arrow-wrapper',
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 30000,
        draggable: false,
        pauseOnHover: false,
        pauseOnFocus: false,
        swipe: false,
        cssEase: 'linear',
        variableWidth: true,
        rows: 0,
    });

    $('.slick-apports').slick({
        infinite: false,
        appendArrows: '.slick-arrow-wrapper',
        rows: 0,
        responsive: [
            {
                breakpoint: 1023,
                settings: {
                    infinite: false,
                    appendArrows: '.slick-arrow-wrapper',
                    adaptiveHeight: true,
                },
            },
        ],
    });

    $('.slick-menu').slick({
        mobileFirst: true,
        centerMode: true,
        centerPadding: '0',
        variableWidth: true,
        infinite: true,
        rows: 0,
        responsive: [
            {
                breakpoint: 767,
                settings: 'unslick',
            },
        ],
    });
});
